export default __webpack_public_path__ + "static/media/product4.94f1bc5d.jpg";